import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=5f8b69ee&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=5f8b69ee&prod&scoped=true&lang=css"
import style1 from "./pay.vue?vue&type=style&index=1&id=5f8b69ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8b69ee",
  null
  
)

export default component.exports